import { motion } from "framer-motion";
import { cn } from "@/lib/utils";

interface PricingSkeletonProps {
  className?: string;
  count?: number;
}

export function PricingSkeleton({
  className,
  count = 2,
}: PricingSkeletonProps) {
  return (
    <div className={cn("grid gap-6 md:grid-cols-2 w-full", className)}>
      {Array.from({ length: count }).map((_, index) => (
        <div
          key={index}
          className="rounded-lg border bg-card w-full max-w-md  text-card-foreground shadow-sm overflow-hidden"
        >
          <div className="p-6 flex flex-col space-y-4">
            {/* Card header */}
            <div className="space-y-2">
              <motion.div
                className="h-7 w-1/3 rounded-md bg-muted"
                animate={{ opacity: [0.5, 0.8, 0.5] }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                  ease: "easeInOut",
                }}
              />
              <motion.div
                className="h-4 w-2/3 rounded-md bg-muted"
                animate={{ opacity: [0.5, 0.7, 0.5] }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                  ease: "easeInOut",
                  delay: 0.1,
                }}
              />
            </div>

            {/* Price */}
            <div className="space-y-1">
              <motion.div
                className="h-10 w-1/2 rounded-md bg-muted"
                animate={{ opacity: [0.5, 0.8, 0.5] }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                  ease: "easeInOut",
                  delay: 0.2,
                }}
              />
              <motion.div
                className="h-4 w-1/4 rounded-md bg-muted"
                animate={{ opacity: [0.5, 0.7, 0.5] }}
                transition={{
                  duration: 1.5,
                  repeat: Number.POSITIVE_INFINITY,
                  ease: "easeInOut",
                  delay: 0.3,
                }}
              />
            </div>

            {/* Features list */}
            <div className="space-y-2">
              {Array.from({ length: 4 }).map((_, i) => (
                <motion.div
                  key={i}
                  className="h-4 w-full rounded-md bg-muted"
                  animate={{ opacity: [0.5, 0.7, 0.5] }}
                  transition={{
                    duration: 1.5,
                    repeat: Number.POSITIVE_INFINITY,
                    ease: "easeInOut",
                    delay: 0.1 * i + 0.4,
                  }}
                />
              ))}
            </div>

            {/* CTA Button */}
            <motion.div
              className="h-10 w-full rounded-md bg-muted mt-auto"
              animate={{ opacity: [0.5, 0.8, 0.5] }}
              transition={{
                duration: 1.5,
                repeat: Number.POSITIVE_INFINITY,
                ease: "easeInOut",
                delay: 0.8,
              }}
            />
          </div>
        </div>
      ))}
    </div>
  );
}
